import { Sidebar, SidebarState } from 'types/Sidebar';
import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';

export const defaultState: SidebarState = {
  [Sidebar.ToolPanel]: true,
  [Sidebar.ScenesPanel]: true
};

export const openSidebar = createActionCreator('SIDEBAR/OPEN', resolve => (sidebar: Sidebar) =>
  resolve(sidebar)
);
export const closeSidebar = createActionCreator('SIDEBAR/CLOSE', resolve => (sidebar: Sidebar) =>
  resolve(sidebar)
);
export const toggleSidebar = createActionCreator('SIDEBAR/TOGGLE', resolve => (sidebar: Sidebar) =>
  resolve(sidebar)
);

export const sidebar = createReducer(defaultState, handle => [
  handle(openSidebar, (state, { payload: sidebar }) => ({ ...state, [sidebar]: true })),
  handle(closeSidebar, (state, { payload: sidebar }) => ({ ...state, [sidebar]: false })),
  handle(toggleSidebar, (state, { payload: sidebar }) => ({ ...state, [sidebar]: !state[sidebar] }))
]);

export const isSidebarOpen = (sidebar: Sidebar) => (state: AppState): boolean =>
  state.sidebar[sidebar];
